import { useState, useEffect } from "react";

import { updateDoc, serverTimestamp, doc, getDoc } from "firebase/firestore";
import { db, auth } from "../../firebase";

export default function EditForm(props) {
  const [title, setTitle] = useState("");
  const [text, setText] = useState("");

  /* function to add new task to firestore */
  const month = props.month;
  useEffect(() => {
    console.log("effect in EditForm");
    //const month = props.month;

    async function fetchData() {
      const docRef = doc(db, month, props.id);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        console.log(" (EditForm) Document data:", docSnap.data());
      } else {
        // doc.data() will be undefined in this case
        console.log("No such document!");
      }
      setTitle(docSnap.data().title);
      setText(docSnap.data().text);
    }

    fetchData();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const user = auth.currentUser;
    const ItemRef = doc(db, month, props.id);
    const docSnap = await getDoc(ItemRef);
    try {
      await updateDoc(ItemRef, {
        title: title,
        text: text,
        updated: serverTimestamp(),
        userUID: user.uid,
      });

      setTitle("");
      setText("");
      props.handleView();
    } catch (err) {
      alert(err);
    }
  };

  function TitlehandleChange(e) {
    setTitle(e.target.value);
  }

  function TexthandleChange(e) {
    setText(e.target.value);
  }

  return (
    <form onSubmit={handleSubmit} className="stack-small">
      <div className="form-group">
        {/* <label htmlFor="item_name" className="label__lg">
          Τίτλος
        </label> */}

        <div class="col-auto">
          <input
            type="text"
            id="item_name"
            name="item_name"
            autoComplete="off"
            value={title}
            onChange={TitlehandleChange}
          />
        </div>

        {/* <label htmlFor="item_comment" className="label__lg">
          Σχόλια
        </label> */}

        <div class="col-auto">
          <textarea
            rows="9"
            columns="10"
            id="item_comment"
            name="item_comment"
            autoComplete="off"
            value={text}
            onChange={TexthandleChange}
          >
            {" "}
          </textarea>
        </div>

        <br></br>

        <button
          type="submit"
          class="btn btn-primary btn-circle btn-circle-lg m-1"
        >
          <i class="fa fa-check"></i>Save
        </button>
        <button class="btn btn-danger btn-circle btn-circle-lg m-1">
          <i class="fa fa-cog"></i> Back
        </button>
      </div>
    </form>
  );
}
